var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.overlayContent }, [
    _c(
      "div",
      { class: [_vm.$style[_vm.iconAlignment], _vm.$style.wrapper] },
      [
        _vm.icon
          ? _c("VsIcon", {
              class: [_vm.$style.icon],
              attrs: { icon: _vm.icon }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { class: _vm.$style.textWrapper }, [
          _c(
            "h4",
            { class: [_vm.$style.marginTop1, _vm.$style.marginBottom1] },
            [_vm._t("title")],
            2
          ),
          _vm._v(" "),
          _c(
            "p",
            { class: [_vm.$style.marginTop1, _vm.$style.marginBottom1] },
            [_vm._t("message")],
            2
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: [_vm.$style.marginTop4, _vm.$style.content] },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }